import { Routes, Route, Link } from "react-router-dom";
import { Toaster } from "sonner";
import { useI18n } from "@/lib/i18n";

import PublicLayout from "@/pages/public/Layout";
import Home from "@/pages/public/Home";
import About from "@/pages/public/About";
import Contact from "@/pages/public/Contact";
import Editorial from "@/pages/public/Editorial";
import Factcheck from "@/pages/public/Factcheck";
import FactcheckDetail from "@/pages/public/FactcheckDetail";
import ArticleDetail from "@/pages/public/ArticleDetail";
import CategoriesDetail from "@/pages/public/CategoriesDetail";
import RubriqueDetail from "@/pages/public/RubriqueDetail";
import Languages from "@/pages/public/Languages";
import Live from "@/pages/public/Live";
import Privacy from "@/pages/public/Privacy";
import Terms from "@/pages/public/Terms";
import Search from "@/pages/public/Search";
import RecapHebdomadaire from "@/pages/public/RecapHebdomadaire";
import Desinscription from "@/pages/public/Desinscription";

import InviteAccept from "@/pages/InviteAccept";

import AdminLayout from "@/pages/admin/Layout";
import RequireAdmin from "@/pages/admin/RequireAdmin";
import AdminIndex from "@/pages/admin/Index";
import AdminLogin from "@/pages/admin/Login";
import AdminDashboard from "@/pages/admin/Dashboard";
import AdminAnalytics from "@/pages/admin/Analytics";
import AdminAvatars from "@/pages/admin/Avatars";
import AdminContent from "@/pages/admin/Content";
import AdminArticleNouveau from "@/pages/admin/ArticleNouveau";
import AdminDisinformation from "@/pages/admin/Disinformation";
import AdminFactchecks from "@/pages/admin/Factchecks";
import AdminCategories from "@/pages/admin/Categories";
import AdminRubriques from "@/pages/admin/Rubriques";
import AdminEtiquettes from "@/pages/admin/Etiquettes";
import AdminLive from "@/pages/admin/Live";
import AdminRoles from "@/pages/admin/Roles";
import AdminSecurity from "@/pages/admin/Security";
import AdminSettings from "@/pages/admin/Settings";
import AdminSources from "@/pages/admin/Sources";
import AdminTranslations from "@/pages/admin/Translations";
import AdminWorkflow from "@/pages/admin/Workflow";
import AdminNewsletter from "@/pages/admin/Newsletter";
import AdminMessages from "@/pages/admin/Messages";
import DetailArticle from "./pages/admin/DetailArticle";
import DetailVerification from "./pages/admin/DetailVerification";

function NotFound() {
  const { t } = useI18n();
  return (
    <div className="flex min-h-screen items-center justify-center bg-background px-4">
      <div className="max-w-md text-center">
        <h1 className="text-7xl font-bold text-foreground">404</h1>
        <h2 className="mt-4 text-xl font-semibold text-foreground">
          {t("error.404.title")}
        </h2>
        <p className="mt-2 text-sm text-muted-foreground">
          {t("error.404.desc")}
        </p>
        <div className="mt-6">
          <Link
            to="/"
            className="inline-flex items-center justify-center rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground transition-colors hover:bg-primary/90"
          >
            {t("error.404.cta")}
          </Link>
        </div>
      </div>
    </div>
  );
}

export default function App() {
  return (
    <>
      <Toaster position="bottom-right" richColors />
      <Routes>
      {/* Public site (with header / footer / mobile nav) */}
      <Route element={<PublicLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/editorial" element={<Editorial />} />
        <Route path="/factcheck" element={<Factcheck />} />
        <Route path="/factcheck/:slug" element={<FactcheckDetail />} />
        <Route path="/article/:slug" element={<ArticleDetail />} />
        <Route path="/categories/:slug" element={<CategoriesDetail />} />
        <Route path="/rubrique/:slug" element={<RubriqueDetail />} />
        <Route path="/languages" element={<Languages />} />
        <Route path="/live" element={<Live />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/search" element={<Search />} />
        <Route path="/recap-hebdomadaire" element={<RecapHebdomadaire />} />
        <Route path="/desinscription" element={<Desinscription />} />
      </Route>

      <Route path="/redaction/login" element={<AdminLogin />} />
      <Route path="/invitation/accepter" element={<InviteAccept />} />


      <Route element={<RequireAdmin />}>
        <Route path="/redaction" element={<AdminLayout />}>
          <Route index element={<AdminIndex />} />
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="analytics" element={<AdminAnalytics />} />
          <Route path="avatars" element={<AdminAvatars />} />
          <Route path="articles" element={<AdminContent />} />
          <Route path="articles/nouveau" element={<AdminArticleNouveau />} />
          <Route path="articles/:id" element={<DetailArticle />} />
          <Route path="verifications/:id" element={<DetailVerification />} />
          <Route path="disinformation" element={<AdminDisinformation />} />
          <Route path="factchecks" element={<AdminFactchecks />} />
          <Route path="categories" element={<AdminCategories />} />
          <Route path="rubriques" element={<AdminRubriques />} />
          <Route path="etiquettes" element={<AdminEtiquettes />} />
          <Route path="live" element={<AdminLive />} />
          <Route path="newsletter" element={<AdminNewsletter />} />
          <Route path="messages" element={<AdminMessages />} />
          <Route path="roles" element={<AdminRoles />} />
          <Route path="security" element={<AdminSecurity />} />
          <Route path="settings" element={<AdminSettings />} />
          <Route path="sources" element={<AdminSources />} />
          <Route path="translations" element={<AdminTranslations />} />
          <Route path="workflow" element={<AdminWorkflow />} />
        </Route>
      </Route>

      <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  );
}
